import dayjs from 'dayjs';

export const applyTimeZone = (date: string, timeZone: number) =>
	dayjs(date).utc().utcOffset(timeZone).format('YYYY-MM-DD HH:mm:ss');
